/* unplugin-vue-components disabled */const { computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-0180b01f"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "card" };
const _hoisted_2 = { style: { "display": "flex", "flex-direction": "column", "gap": "5px" } };
const _hoisted_3 = { class: "coord-wrap" };
const _hoisted_4 = _withScopeId(() => (0, vue_2.createElementVNode)("div", null, "参考坐标系", -1));
const _hoisted_5 = {
    align: "middle",
    class: "position"
};
const _hoisted_6 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "X", -1));
const _hoisted_7 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "Y", -1));
const _hoisted_8 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "Z", -1));
const work_1 = require("@/store/modules/work");
const model_1 = require("@/model");
const SliderItem_vue_1 = tslib_1.__importDefault(require("./SliderItem.vue"));
const MachineItem_vue_1 = tslib_1.__importDefault(require("./MachineItem.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'UcsPanel',
    props: {
        machine: {
            type: model_1.Machine,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        isReferenceReadOnly: {
            type: Boolean,
            default: false
        },
        isShowDelBtn: {
            type: Boolean,
            default: true
        },
    },
    emits: ['delConfirm', 'update:machine'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const store = (0, work_1.useWork)();
        const reference = computed({
            get() {
                var _a, _b, _c, _d;
                if (((_b = (_a = props.machine) === null || _a === void 0 ? void 0 : _a.reference) === null || _b === void 0 ? void 0 : _b.frame) != 'ucs') {
                    return ((_d = (_c = props.machine) === null || _c === void 0 ? void 0 : _c.reference) === null || _d === void 0 ? void 0 : _d.frame) || coordinateSystem.value[0].value || 0;
                }
                else {
                    return props.machine.originMachine.id;
                }
            },
            set(val) {
                if (props.machine.type === model_1.ENTITY_TYPE.UCS || props.machine.type === model_1.ENTITY_TYPE.TCP) {
                    if (['global', 'base', 'tool'].includes(val)) {
                        props.machine.setReference(val);
                    }
                    else {
                        let origin = model_1.Project.current().findTargetById(val);
                        if (origin) {
                            props.machine.setReference('ucs', val);
                        }
                        else {
                            console.error('origin is null');
                        }
                    }
                }
                return props.machine.reference.frame;
            }
        });
        const coordinateSystem = computed(() => {
            return props.machine.getUcs().map(e => {
                return { label: e.name, value: e.id };
            });
        });
        const emit = __emit;
        const machineModel = computed({
            get() {
                return props.machine;
            },
            set(value) {
                emit('update:machine', props.machine);
            }
        });
        function onZAngleChangeCallback(index, val, key) {
            machineModel.value.pr[key.toLowerCase()] = val;
        }
        function onClickDel() {
            emit('delConfirm');
        }
        return (_ctx, _cache) => {
            const _component_el_option = (0, vue_2.resolveComponent)("el-option");
            const _component_el_select = (0, vue_2.resolveComponent)("el-select");
            const _component_el_input_number = (0, vue_2.resolveComponent)("el-input-number");
            const _component_el_card = (0, vue_2.resolveComponent)("el-card");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_card, null, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "header"),
                            (0, vue_2.createVNode)(MachineItem_vue_1.default, {
                                machine: __props.machine,
                                "is-read-only": __props.isReadOnly,
                                "is-show-del-btn": __props.isShowDelBtn,
                                id: "ucs-machine-item",
                                onDelConfirm: onClickDel
                            }, null, 8, ["machine", "is-read-only", "is-show-del-btn"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                _hoisted_4,
                                (0, vue_2.createVNode)(_component_el_select, {
                                    disabled: __props.isReadOnly || __props.isReferenceReadOnly,
                                    modelValue: (0, vue_2.unref)(reference),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(reference) ? (reference).value = $event : null))
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(coordinateSystem), (item, index) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                                key: index,
                                                label: item.label,
                                                value: item.value
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.label), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["label", "value"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }, 8, ["disabled", "modelValue"])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            _hoisted_6,
                            (0, vue_2.createVNode)(_component_el_input_number, {
                                class: "input-number",
                                modelValue: (0, vue_2.unref)(machineModel).pr.x,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(machineModel).pr.x) = $event)),
                                precision: 2,
                                step: 0.1,
                                placeholder: "inputX",
                                disabled: __props.isReadOnly,
                                controls: false,
                                "value-on-clear": 0
                            }, null, 8, ["modelValue", "disabled"]),
                            _hoisted_7,
                            (0, vue_2.createVNode)(_component_el_input_number, {
                                class: "input-number",
                                modelValue: (0, vue_2.unref)(machineModel).pr.y,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (((0, vue_2.unref)(machineModel).pr.y) = $event)),
                                precision: 2,
                                step: 0.1,
                                disabled: __props.isReadOnly,
                                placeholder: "inputY",
                                "value-on-clear": 0,
                                controls: false
                            }, null, 8, ["modelValue", "disabled"]),
                            _hoisted_8,
                            (0, vue_2.createVNode)(_component_el_input_number, {
                                class: "input-number",
                                modelValue: (0, vue_2.unref)(machineModel).pr.z,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(machineModel).pr.z) = $event)),
                                precision: 2,
                                step: 0.1,
                                disabled: __props.isReadOnly,
                                placeholder: "inputZ",
                                "value-on-clear": 0,
                                controls: false
                            }, null, 8, ["modelValue", "disabled"])
                        ]),
                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['Rx', 'Ry', 'Rz'], (key, index) => {
                            return (0, vue_2.createElementVNode)("div", {
                                key: `angle-${key}`
                            }, [
                                (0, vue_2.createVNode)(SliderItem_vue_1.default, {
                                    name: key,
                                    disable: __props.isReadOnly,
                                    "onUpdate:item": (val) => onZAngleChangeCallback(index, val, key),
                                    minLimit: -360,
                                    item: (0, vue_2.unref)(machineModel).pr[key.toLowerCase()],
                                    showLimit: false
                                }, null, 8, ["name", "disable", "onUpdate:item", "item"])
                            ]);
                        }), 64)),
                        (0, vue_2.renderSlot)(_ctx.$slots, "footer")
                    ])
                ]),
                _: 3
            }));
        };
    }
});
